import { createAsyncThunk } from "@reduxjs/toolkit";
import apiCall from "../AuthorizedApi";
import { showErrorToast } from "../../../components/atoms/Utlis/Toast";
export const createPackageAPI = createAsyncThunk(
    'package/createPackageAPI',
    async (data: { title: string, price: number, description: string, website?: string, youtube_link?: string, insta_link?: string, facebook_link?: string }, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'POST',
                url: `/plans/business-package/`,
                data
            })
            // console.log(response);
            return response.data;
        } catch (error: any) {

            return rejectWithValue(error.response.data);
        }
    });
export const getAllPackageAPI = createAsyncThunk(
    'package/getAllPackageAPI',
    async (data: { user_id: number }, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'GET',
                url: `/plans/business-package/?user_id=${data.user_id}`,
            })
            // console.log(response);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });
export const updatePackageAPI = createAsyncThunk(
    'package/updatePackageAPI',
    async (data: { package_id: number, description: string, title: string, price: number, website?: string, facebook_link?: string, insta_link?: string, youtube_link?: string }, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'PUT',
                url: `/plans/business-package/`,
                data
            })
            // console.log(response);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });
export const deletePackageAPI = createAsyncThunk(
    'package/deletePackageAPI',
    async (data: { package_id: number }, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'DELETE',
                url: `/plans/business-package/?package_id=${data.package_id}`,
            })
            // console.log(response);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });
export const getAllPackageTransactions = createAsyncThunk(
    'package/getAllPackageTransactions',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'GET',
                url: `plans/studio-package-transaction/`,
            })
            // console.log(response);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });
export const sendAccountInfoAPI = createAsyncThunk(
    'package/sendAccountInfoAPI',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'POST',
                url: `/account/user/bank-detail/`,
                data
            })
            console.log(response);
            return response?.data ?? response;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });

export const getAccountInfoAPI = createAsyncThunk(
    'package/getAccountInfoAPI',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'GET',
                url: `/account/user/bank-detail/`,
            })
            console.log(response);
            return response?.data ?? response;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });

export const updateAccountInfoAPI = createAsyncThunk(
    'package/updateAccountInfoAPI',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'PUT',
                url: `/account/user/bank-detail/`,
                data
            })
            console.log(response);
            return response?.data ?? response;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });

export const getCashfreeVendorStatusAPI = createAsyncThunk(
    'package/getCashfreeVendorStatusAPI',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'GET',
                url: `/account/user/cashfree-vendor/status/`,
            })
            console.log(response);
            return response?.data ?? response;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });

export const getPackageRequestAPI = createAsyncThunk(
    'package/getPackageRequestAPI',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'GET',
                url: `/plans/admin/packages/price/requests/`,
            })
            console.log(response, "responsee packagesssss");
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });

export const sendPackageApprovePriceAPI = createAsyncThunk(
    'package/sendPackageApprovePriceAPI',
    async (data: { price?: number, action: string, request_ids: number[] }, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'POST',
                url: `/plans/admin/packages/price/approve/`,
                data
            })
            console.log(response, "package approve");
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    });
export const updatePackagePriceStatusAPI = createAsyncThunk(
    'package/updatePackagePriceStatusAPI',
    async (data: { user_id?: number, data: any }, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'PUT',
                url: `/plans/business-package/?user_id=${data.user_id}`,
                data: data.data
            })
            // console.log(response);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }

    });
export const getPackageBookingAPI = createAsyncThunk(
    'package/getPackageBookingAPI',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'GET',
                url: `/plans/admin/all/bookings/`,
            })
            // console.log(response);
            return response;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }

    });

export const completePackagePaymentAPI = async (token: string) => {
    try {
        const response = await apiCall({
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            url: `/plans/check-payment-status_v2/`,
            data: {
                token,
            },
        });
        // console.log(response);
        return response;
    } catch (error: any) {
        console.log("error", error);
        showErrorToast("Error in payment completion.");
        return null;
    }
};

export const GenerateBookPackagePaymentAPI = async ({
    amount,
    booking_id,
    contact_details,
    customer_name,
    description,
    payment_provider,
    return_url,
}: {
    amount: number;
    booking_id: string;
    contact_details: string;
    customer_name: string;
    description: string;
    payment_provider: "cashfree" | "razorpay";
    return_url: string;
}) => {
    try {
        const response = await apiCall({
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            url: `/plans/admin/booking/create-payment-link_v2/`,
            data: {
                amount,
                booking_id,
                customer_name,
                contact_details,
                description,
                payment_provider,
                return_url,
            },
        });
        // console.log(response);
        return response;
    } catch (error: any) {
        console.log("error", error);
        showErrorToast("Error in payment link generation.");
        return null;
    }
};


export const addManualPaymentAPI = async ({
    amount,
    booking_id,
    contact_details,
    customer_name,
    description,
    payment_method,
}: {
    amount: number;
    booking_id: string;
    contact_details: string;
    customer_name: string;
    description: string;
    payment_method: string;
}) => {
    try {
        const response = await apiCall({
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            url: `/plans/admin/manual-booking-payment/`,
            data: {
                amount,
                booking_id,
                contact_details,
                customer_name,
                description,
                payment_method,
            },
        });
        // console.log(response);
        return response;
    } catch (error: any) {
        console.log("error", error);
        showErrorToast("Error in payment link generation.");
        return null;
    }
};

export const showBookingPaymentHistory = async (booking_id: string) => {
    try {
        const res = apiCall({
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            url: `plans/booking-transactions/?booking_id=${booking_id}`,
        })
        return res;
    } catch (error: any) {
        showErrorToast("Error in fetching transaction history.");
        return null;
    }
}